import tokenImage from "../img/tokens/token.png";

export const launchpadSchema = {
  name: "",
  image: "",
  desc: "",
  likes: 0,
  audited: false,
  verified: false,
  bnbPrice: 0,
  cap: [0, 0],
  progress: 0,
  liquidity: 0,
  lockup: 0,
  cancelled: false,
  startDate: 0,
  endDate: 0,
  category: "",
  score: 0,
  kyc: "",
  size: "",
  locked: "",
  lockPeriod: "",
  lockDuration: "",
  audit: "",
  website: "",
  social: { tg: "/", twitter: "/" },
  utility: "",
  privateSale: "",
  vesting: "",
  ratio: "",
  voteScore: "",
  level: "",
  id: 0,
};

export const launchpadsArray = [
  {
    name: "",
    image: "",
    desc: "",
    likes: 0,
    audited: false,
    verified: false,
    bnbPrice: 0,
    cap: [0, 0],
    progress: 0,
    liquidity: 0,
    lockup: 0,
    cancelled: false,
    startDate: 0,
    endDate: 0,
    category: "",
    score: 0,
    kyc: false,
    size: "",
    locked: "",
    lockPeriod: "",
    lockDuration: "",
    audit: "",
    website: "",
    social: { tg: "/", twitter: "/" },
    utility: "",
    privateSale: "",
    vesting: "",
    ratio: "",
    voteScore: "",
    level: "",
    id: "",
    admin: "",
    address: "",
    symbol: "",
    decimals: "",
    maxSupply: "",
    listPrice: "",
    buy: ["", ""],
    sold: "",
    tokenForSale: "",
    tokenForLiquidity: "",
    launchpadAddress: "",
    values: [],
  },
  {
    name: "EFT TOKEN",
    image: tokenImage,
    desc: "Airdrop for Those who have filled google form to claim EFT on the basis of participation in old Airdrop Program ...",
    likes: 128,
    audited: true,
    verified: true,
    bnbPrice: 1,
    cap: [125, 250],
    progress: 30,
    liquidity: 65,
    lockup: 370,
    cancelled: false,
    startDate: 1651841806000,
    endDate: 1654520206000,
    category: "DeFi",
    score: 70,
    kyc: "XXX",
    size: "XXX",
    locked: "XXX",
    lockPeriod: "XXX",
    lockDuration: "XXX",
    audit: "XXX",
    website: "eft-token.io",
    social: { tg: "/", twitter: "/" },
    utility: "XXX",
    privateSale: "XXX",
    vesting: "XXX",
    ratio: "XXX",
    voteScore: "XXX",
    level: "mid",
    id: 1,
  },
  {
    name: "EFT TOKEN",
    image: tokenImage,
    desc: "Airdrop for Those who have filled google form to claim EFT on the basis of participation in old Airdrop Program ...",
    likes: 128,
    audited: false,
    verified: true,
    bnbPrice: 1,
    cap: [125, 250],
    progress: 30,
    liquidity: 65,
    lockup: 370,
    cancelled: true,
    startDate: 1654520333000,
    endDate: 1657112333000,
    category: "DeFi",
    score: 70,
    kyc: "XXX",
    size: "XXX",
    locked: "XXX",
    lockPeriod: "XXX",
    lockDuration: "XXX",
    audit: "XXX",
    website: "eft-token.io",
    social: { tg: "/", twitter: "/" },
    utility: "XXX",
    privateSale: "XXX",
    vesting: "XXX",
    ratio: "XXX",
    voteScore: "XXX",
    level: "low",
    id: 2,
  },
  {
    name: "EFT TOKEN",
    image: tokenImage,
    desc: "Airdrop for Those who have filled google form to claim EFT on the basis of participation in old Airdrop Program ...",
    likes: 128,
    audited: false,
    verified: false,
    bnbPrice: 1,
    cap: [125, 250],
    progress: 30,
    liquidity: 65,
    lockup: 370,
    cancelled: false,
    startDate: 1644152333000,
    endDate: 1646571533000,
    category: "DeFi",
    score: 70,
    kyc: "XXX",
    size: "XXX",
    locked: "XXX",
    lockPeriod: "XXX",
    lockDuration: "XXX",
    audit: "XXX",
    website: "eft-token.io",
    social: { tg: "/", twitter: "/" },
    utility: "XXX",
    privateSale: "XXX",
    vesting: "XXX",
    ratio: "XXX",
    voteScore: "XXX",
    level: "high",
    id: 3,
  },
  {
    name: "EFT TOKEN",
    image: tokenImage,
    desc: "Airdrop for Those who have filled google form to claim EFT on the basis of participation in old Airdrop Program ...",
    likes: 128,
    audited: false,
    verified: false,
    bnbPrice: 1,
    cap: [125, 250],
    progress: 30,
    liquidity: 65,
    lockup: 370,
    cancelled: false,
    startDate: 1651841806000,
    endDate: 1654520206000,
    category: "DeFi",
    score: 70,
    kyc: "XXX",
    size: "XXX",
    locked: "XXX",
    lockPeriod: "XXX",
    lockDuration: "XXX",
    audit: "XXX",
    website: "eft-token.io",
    social: { tg: "/", twitter: "/" },
    utility: "XXX",
    privateSale: "XXX",
    vesting: "XXX",
    ratio: "XXX",
    voteScore: "XXX",
    level: "low",
    id: 4,
  },
  {
    name: "EFT TOKEN",
    image: tokenImage,
    desc: "Airdrop for Those who have filled google form to claim EFT on the basis of participation in old Airdrop Program ...",
    likes: 128,
    audited: false,
    verified: true,
    bnbPrice: 1,
    cap: [125, 250],
    progress: 30,
    liquidity: 65,
    lockup: 370,
    cancelled: true,
    startDate: 1654520333000,
    endDate: 1657112333000,
    category: "DeFi",
    score: 70,
    kyc: "XXX",
    size: "XXX",
    locked: "XXX",
    lockPeriod: "XXX",
    lockDuration: "XXX",
    audit: "XXX",
    website: "eft-token.io",
    social: { tg: "/", twitter: "/" },
    utility: "XXX",
    privateSale: "XXX",
    vesting: "XXX",
    ratio: "XXX",
    voteScore: "XXX",
    level: "mid",
    id: 5,
  },
];

export const contributionsArray = [
  {
    name: "EFT TOKEN 2",
    image: tokenImage,
    desc: "Airdrop for Those who have filled google form to claim EFT on the basis of participation in old Airdrop Program ...",
    likes: 12,
    audited: false,
    verified: false,
    bnbPrice: 1,
    cap: [125, 250],
    progress: 30,
    liquidity: 65,
    lockup: 370,
    cancelled: false,
    startDate: 1651841806000,
    endDate: 1654520206000,
    category: "DeFi",
    score: 70,
    kyc: "XXX",
    size: "XXX",
    locked: "XXX",
    lockPeriod: "XXX",
    lockDuration: "XXX",
    audit: "XXX",
    website: "eft-token.io",
    social: { tg: "/", twitter: "/" },
    utility: "XXX",
    privateSale: "XXX",
    vesting: "XXX",
    ratio: "XXX",
    voteScore: "XXX",
    level: "low",
    id: 1,
  },
  {
    name: "EFT TOKEN 2",
    image: tokenImage,
    desc: "Airdrop for Those who have filled google form to claim EFT on the basis of participation in old Airdrop Program ...",
    likes: 11,
    audited: false,
    verified: false,
    bnbPrice: 1,
    cap: [125, 250],
    progress: 30,
    liquidity: 65,
    lockup: 370,
    cancelled: true,
    startDate: 1654520333000,
    endDate: 1657112333000,
    category: "DeFi",
    score: 70,
    kyc: "XXX",
    size: "XXX",
    locked: "XXX",
    lockPeriod: "XXX",
    lockDuration: "XXX",
    audit: "XXX",
    website: "eft-token.io",
    social: { tg: "/", twitter: "/" },
    utility: "XXX",
    privateSale: "XXX",
    vesting: "XXX",
    ratio: "XXX",
    voteScore: "XXX",
    level: "high",
    id: 2,
  },
  {
    name: "EFT TOKEN 2",
    image: tokenImage,
    desc: "Airdrop for Those who have filled google form to claim EFT on the basis of participation in old Airdrop Program ...",
    likes: 128,
    audited: true,
    verified: true,
    bnbPrice: 1,
    cap: [125, 250],
    progress: 30,
    liquidity: 65,
    lockup: 370,
    cancelled: false,
    startDate: 1644152333000,
    endDate: 1646571533000,
    category: "DeFi",
    score: 70,
    kyc: "XXX",
    size: "XXX",
    locked: "XXX",
    lockPeriod: "XXX",
    lockDuration: "XXX",
    audit: "XXX",
    website: "eft-token.io",
    social: { tg: "/", twitter: "/" },
    utility: "XXX",
    privateSale: "XXX",
    vesting: "XXX",
    ratio: "XXX",
    voteScore: "XXX",
    level: "mid",
    id: 0,
  },
  {
    name: "EFT TOKEN 2",
    image: tokenImage,
    desc: "Airdrop for Those who have filled google form to claim EFT on the basis of participation in old Airdrop Program ...",
    likes: 128,
    audited: false,
    verified: false,
    bnbPrice: 1,
    cap: [125, 250],
    progress: 30,
    liquidity: 65,
    lockup: 370,
    cancelled: false,
    startDate: 1644152333000,
    endDate: 1646571533000,
    category: "DeFi",
    score: 70,
    kyc: "XXX",
    size: "XXX",
    locked: "XXX",
    lockPeriod: "XXX",
    lockDuration: "XXX",
    audit: "XXX",
    website: "eft-token.io",
    social: { tg: "/", twitter: "/" },
    utility: "XXX",
    privateSale: "XXX",
    vesting: "XXX",
    ratio: "XXX",
    voteScore: "XXX",
    level: "low",
    id: 3,
  },
];

export const allAirdrops = [
  {
    name: "",
    image: "",
    description: "",
    token: "",
    decimals: "",
    totalToken: "",
    participants: "",
    cancelled: "",
    startDate: "",
    allocations: "",
    distributed: "",
    progress: "",
    status: "",
    admin: "",
    tokenName: "",
    tokenSymbol: "",
    tokenAddress: "",
    airdropAddress: "",
  },
  {
    name: "EFT AIRDROP",
    image: tokenImage,
    token: "EFT",
    totalToken: "10.000.000.000",
    participants: 12,
    cancelled: false,
    startDate: 1644152333000,
    endDate: 1646571533000,
    id: 2,
  },
  {
    name: "EFT AIRDROP",
    image: tokenImage,
    token: "EFT",
    totalToken: "10.000.000.000",
    participants: 12,
    cancelled: true,
    startDate: 1654520333000,
    endDate: 1657112333000,
    id: 3,
  },
  {
    name: "EFT AIRDROP",
    image: tokenImage,
    token: "EFT",
    totalToken: "10.000.000.000",
    participants: 12,
    cancelled: false,
    startDate: 1644152333000,
    endDate: 1646571533000,
    id: 4,
  },
  {
    name: "EFT AIRDROP",
    image: tokenImage,
    token: "EFT",
    totalToken: "10.000.000.000",
    participants: 12,
    cancelled: false,
    startDate: 1651841806000,
    endDate: 1654520206000,
    id: 5,
  },
  {
    name: "EFT AIRDROP",
    image: tokenImage,
    token: "EFT",
    totalToken: "10.000.000.000",
    participants: 12,
    cancelled: true,
    startDate: 1654520333000,
    endDate: 1657112333000,
    id: 6,
  },
];

export const myAirdrops = [
  {
    name: "EFT AIRDROP",
    image: tokenImage,
    token: "EFT",
    totalToken: "10.000.000.000",
    participants: 12,
    cancelled: false,
    startDate: 1644152333000,
    endDate: 1646571533000,
    id: 1,
  },
  {
    name: "EFT AIRDROP",
    image: tokenImage,
    token: "EFT",
    totalToken: "10.000.000.000",
    participants: 12,
    cancelled: true,
    startDate: 1654520333000,
    endDate: 1657112333000,
    id: 2,
  },
  {
    name: "EFT AIRDROP",
    image: tokenImage,
    token: "EFT",
    totalToken: "10.000.000.000",
    participants: 12,
    cancelled: false,
    startDate: 1644152333000,
    endDate: 1646571533000,
    id: 3,
  },
];

export const createdAirdrops = [
  {
    name: "EFT AIRDROP",
    image: tokenImage,
    token: "EFT",
    totalToken: "10.000.000.000",
    participants: 12,
    cancelled: false,
    startDate: 1644152333000,
    endDate: 1646571533000,
    id: 1,
  },
];
